import React, { useState } from "react";
import PageHeading from "../../components/PageHeading";
import { useQuery, useQueryClient } from "react-query";

import imageManagerServices from "../../services/imageManager";

import { Navigate } from "react-router-dom";
import DCard from "../../components/DCard";
import DSpinner from "../../components/DSpinner";
import Table from "../../components/Table";
import DButton from "../../components/DButton";
import { useDisclosure } from "@chakra-ui/react";
import DModal from "../../components/DModal";
import { toast } from "react-hot-toast";
import DImage from "../../components/DImage";

const columns = [
  { Header: "صورة", accessor: "img" },
  { Header: "العمليات", accessor: "actions" },
];
const Index = ({ title }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const queryClient = useQueryClient();
  const [currentPage, setCurrentPage] = useState(0);
  const [deleteImageId, setDeleteImageId] = useState();
  const { data, isLoading, error } = useQuery(
    ["getAllImages", currentPage],
    () => imageManagerServices.getAllImages(currentPage + 1),
    { staleTime: 10000, cacheTime: 10000 }
  );

  const copyImageUrl = (url) => {
    navigator.clipboard
      .writeText(url)
      .then(() => {
        toast.success("تم نسخ الرابط بنجاح!");
      })
      .catch((err) => {
        toast.error("حدث خطأ أثناء النسخ:", err);
      });
  };
  const deleteImage = () => {
    onClose();
    imageManagerServices
      .deleteImage(deleteImageId)
      .then((res) => {
        toast.success("تم الحذف بنجاح");
        queryClient.refetchQueries(["getAllImages"]);
      })
      .catch((err) => {
        if (err.response.status === 404) {
          toast.error("القسم غير موجود");
        } else {
          toast.error("حصل خطأ ما");
        }
      });
  };
  const getFormattedData = (data) => {
    return data.map((d) => ({
      ...d,
      img: (
        <div className="relative w-[100px] h-[100px] mx-auto">
          {/* <img src={d} alt={d} /> */}
          {/* <img src="pic_trulli.jpg" alt="Italian Trulli"></img> */}
          <DImage src={d} alt={d} load={true} />
        </div>
      ),

      actions: (
        <div className="flex items-center justify-center gap-2">
          <DButton
            onClick={() => copyImageUrl(d)}
            bgColor="primary"
            className=" px-4 text-white  rounded-[50px_!important]"
          >
            نسخ الرابط
          </DButton>
          {d.id !== 1 && (
            <DButton
              bgColor="danger"
              className={"text-white px-4 rounded-[50px_!important]"}
              onClick={() => {
                onOpen();
                setDeleteImageId(d);
              }}
            >
              حذف
            </DButton>
          )}
        </div>
      ),
    }));
  };
  if (error) {
    return <Navigate to="/404" />;
  }
  return (
    <div>
      <DModal
        isOpen={isOpen}
        onClose={onClose}
        modelType="delete"
        clickHandler={deleteImage}
        bodyText="هل تريد حذف الصورة"
      />
      <PageHeading>{title}</PageHeading>
      <DCard className={`relative ${isLoading ? "min-h-[400px]" : ""}`}>
        {isLoading ? (
          <DSpinner />
        ) : (
          <Table
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalData={data.data.total}
            head={columns}
            body={getFormattedData(data.data.data)}
          />
        )}
      </DCard>
    </div>
  );
};

export default Index;
